import {Component, Vue} from 'vue-facing-decorator';

import HeaderMenu from '@/components/HeaderMenu/HeaderMenu.vue';
import BottomMenu from '@/components/BottomMenu/BottomMenu.vue';

@Component({
    name: 'main-root',
    components: {
        'MenuBar' : HeaderMenu,
        'app-bottom-menu' :BottomMenu, // CurvedBottomNavigation
    }
})
export default class Main extends Vue{
    isIklan = false

    showGif= true

    mounted() {
        setTimeout(() => {
          this.showGif = false;
        }, 1000); // Tampilkan GIF selama 5 detik
      }

   get app_base_data() {
    return this.$store.state.baseData;
   }

   goToLink(link: any){
        if(link){
            window.open(link, '_blank')
        }
   }
}